// extracted by mini-css-extract-plugin
export default {"wrapper":"_88f5d7cc","title":"_16f0795f","copy":"_565c851a","message":"_7bda1d94","messageBold":"_8953f431"};